import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducerCreator from '../reducers';
import { createRouterMiddleware } from '@lagunovsky/redux-react-router'

const store = (initialState, history) => {
  return createStore(
    rootReducerCreator(history),
    initialState,
    applyMiddleware(thunk, createRouterMiddleware(history))
  );
};

export default store